<template>
  <div id="cart-product-list">
    <div class="cart-product-list-header">
      <ul>
        <li>{{$_('product')}}</li>
        <li>{{$_('size')}}</li>
        <li>{{$_('packaging')}}</li>
        <li>{{$_('quantity')}}</li>
        <li>{{$_('avaibility')}}</li>
        <li>{{$_('price')}}</li>
      </ul>
    </div>
    <div class="cart-product-list-body" v-if="getCart.length > 0">
      <div v-for="(product, index) in getCart" :key="index">
        <CartProductLine :line_data="product" :index="index" />
      </div>
    </div>
    <div v-else>
      <div class="cart-product-list-footer no-result">
        <span>{{$_('no_product_in_cart')}}</span>
      </div>
    </div>
  </div>
</template>

<script>

import CartProductLine from "@/modules/panier/components/CartProductLine";

export default {
  name: "CartProductList",
  data() {
    return {
      products: [],
    };
  },
  components: {
    CartProductLine
  },
  computed: {
    getCart() {
     return this.$store.getters['panier/get_cart'];
    }  
  }

};
</script>

<style scoped>
#cart-product-list {
  padding: 0px 0px;
}
.cart-product-list-header ul {
  display: flex;
}
.cart-product-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 7);
  text-align: left;
  padding: 0px 20px;
  justify-content: center;
}
.cart-product-list-header {
  padding: 15px 0px;
}
.no-result {
  text-align: center;
  padding: 20px;
  border: solid 1px #e9e9e9;
  margin-bottom: 20px;
}
.no-result span {
  color: #8B8B8B;
}
</style>